import { CellProps } from "components/TreeState"
import { NumericCell } from "./NumericCell"
import { ReadonlyCell } from "./ReadonlyCell"
import { useSnapshot } from "valtio"
import { useTableSource } from "../TableStateProvider"
import { usePrecision } from "providers/A12n"
import { memo } from "react"

export const PreciseGrossCostCell = memo(function _PreciseGrossCostCell(
  props: CellProps,
) {
  const precision = usePrecision()
  return <GrossCostCell {...props} precision={precision} />
})

export const GrossCostCell = memo(function _GrossCostCell(props: CellProps) {
  const { rowId: id, editType } = props
  const tableSource = useTableSource()
  const readFrom = useSnapshot(tableSource.state)
  const type = readFrom[id]?.type

  return type === "package" || editType === "Numeric" ? (
    <NumericCell {...props} />
  ) : (
    <ReadonlyCell {...props} />
  )
})
